import React from 'react';
import { Box, Typography } from '@mui/material';
import { CloudArrowUp } from '@phosphor-icons/react';

interface ExternalFileDragIndicatorProps {
  isDragging: boolean;
  position: { x: number; y: number } | null;
  fileCount: number;
}

export const ExternalFileDragIndicator: React.FC<ExternalFileDragIndicatorProps> = ({
  isDragging,
  position,
  fileCount,
}) => {
  if (!isDragging || !position) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px dashed rgba(128, 128, 128, 0.4)',
          pointerEvents: 'none',
          zIndex: 9998,
        }}
      />

      <Box
        sx={{
          position: 'fixed',
          left: position.x,
          top: position.y,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            width: '160px',
            height: '120px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            border: '2px dashed rgba(128, 128, 128, 0.5)',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <CloudArrowUp size={24} weight="regular" color="#808080" />
          <Typography variant="caption" sx={{ color: '#808080', fontSize: '11px' }}>
            Media Box
          </Typography>
          {fileCount > 1 && (
            <Typography variant="caption" sx={{ color: '#808080', fontSize: '9px', opacity: 0.7 }}>
              {fileCount} files
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

